function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.8532,173.0248l-.1989,1.0451H58.3531L57.2247,180h-1.136l1.1284-5.93H54.9044l.1989-1.0451Zm8.512,0L68.038,180h-1.136l.9292-4.8833-2.8319,3.3091h-.6784L62.75,175.107,61.8191,180H60.683l1.3273-6.9752H63.036l1.8915,3.9955,3.41-3.9955ZM71.2008,42.3335,78.4862,3.9884H33.476L0,180H51.1166l13.8029-72.5717C73.0581,64.6346,97.61,47.51,132.55,52.8L142.5323.3A70.8107,70.8107,0,0,0,71.2008,42.3335Z",
  fill: "#eb0000"
});

function SvgRackspaceIconRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.5323 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "r-Artboard 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRackspaceIconRed);
export default __webpack_public_path__ + "static/media/Rackspace_Icon_Red.3829fbc0.svg";
export { ForwardRef as ReactComponent };